// extracted by mini-css-extract-plugin
module.exports = {"section":"section-oyshB","field":"field-EZAey","field-content":"field-content-2RWbQ","fieldContent":"field-content-2RWbQ","label":"label-3nITa","required":"required-1dLLI"};